export const getPaginatedCollection = <T>(collection: T[], page: number, limit: number): T[] => collection.slice((page - 1) * limit, page * limit);
export const getCountPagination = (length: number, limit: number): number => Math.ceil(length / limit);
